export const IconTypes = {
  account: 'account-icon',
  orders: 'orders-icon',
  inventory: 'inventory-icon',
  'support-ticketing': 'support-ticketing-icon',
  ordersPage: 'orders-page',
  inventoryPage: 'inventory-page',
  supportPage: 'support-page',
  triangle: 'nav-triangle',
  checked: 'box-check',
  hidden: 'box-check-hidden',
  dropdown: 'dropdown-triangle',
  xlsxdownload: 'xlsxdownload',
  customize: 'menu-customize-button',
  sort: 'menu-sort-button',
  filter: 'menu-filter-button',
  dots: 'menu-group-button',
  calendar: 'calendar-button',
  copy: 'copy-icon',
  details: 'details-button',
  more: 'more-icon',
  collapse: 'collapse-icon',
  expand: 'expand-icon',
  plus: 'plus-circle',
  arrowDownCircle: 'arrow-down-circle',
  plusRectangle: 'plus-button',
  minus: 'minus-button',
  circlemark: 'circlemark',
  homeIcon: 'home-icon-sidebar',
  inventoryIcon: 'inventory-icon-sidebar',
  processingIcon: 'processing-icon-sidebar',
  adminIcon: 'admin-icon-sidebar',
  linkIcon: 'link-icon-sidebar',
  paymentIcon: 'payment-icon-sidebar',
  historyIcon: 'history-icon-sidebar',
  dataIcon: 'data-icon-sidebar',
  customersIcon: 'customers-icon-sidebar',
  ticketsIcon: 'tickets-icon-sidebar',
  logoutIcon: 'logout-icon-sidebar',
  greyCheckmark: 'grey-checkmark',
  greenCheckmark: 'green-checkmark',
  indigoCheckmark: 'indigo-checkmark',
  alert: 'alert-circle',
  alertWhite: 'alert-circle-white',
  infoCircleBlue: 'info-circle-blue',
  cancel: 'cancel-button',
  retry: 'retry-button',
  trash: 'trash-button',
  myTeam: 'my-team-icon',
  pin: 'pin',
  redCancel: 'red-cancel',
  impersonate: 'impersonate-icon',
  key: 'key',
  settings: 'settings-icon',
  hasNotifications: 'has-notifications-icon',
  noNotifications: 'no-notifications-icon',
  notificationsDot: 'notifications-dot',
  notificationsReadDot: 'notifications-read-dot',
  contact: 'contact-icon',
  logoutSmall: 'logout-small-icon',
  refresh: 'refresh',
  newDoc: 'newDoc',
  external: 'external',
  info: 'info-icon',
  edit: 'edit-icon',
  disabled: 'disabled-icon',
  enabled: 'enabled-icon',
  filterIcon: 'filter-icon',
  densityIcon: 'density-icon',
  columnsIcon: 'columns-icon',
  exportIcon: 'export-icon',
  customerSmall: 'customer-small',
  customerMed: 'customer-med',
  assetSmall: 'asset-small',
  assetMed: 'asset-med',
  provisionalAssetMed: 'provisional-asset-med',
  provisionalAssetSm: 'provisional-asset-sm',
  rpmAccountSmall: 'rpm-account-small',
  rpmAccountMed: 'rpm-account-med',
  ticketSmall: 'ticket-small',
  ticketMed: 'ticket-med',
  trueUpSmall: 'true-up-small',
  rpmIconSidebar: 'rpm-icon-sidebar',
  assetsDoc: 'assets-doc',
  provisionalAssetsDoc: 'provisional-assets-doc',
  customersBuilding: 'customers-building',
  rpmGreen: 'rpm-green',
  tsdSmall: 'tsd-small',
  apSmall: 'ap-small',
  supplierSmall: 'supplier-small',
  supplierMed: 'supplier-med',
  rpmSupplierSmall: 'rpm-supplier-small',
  leftArrow: 'left-arrow',
  rightArroe: 'right-arrow'
};

export interface IconProps {
  children?: React.ReactNode;
  className?: string;
  type: IconType;
  size?: string;
  onClick?: () => void;
  title?: string;
}

export type IconType = keyof typeof IconTypes;

export const Icon = ({ className = '', type, size = '', children, ...props }: IconProps) => {
  return (
    <div
      {...props}
      className={`${IconTypes[type]} ${size} ${className}`}>
      {children}
    </div>
  );
};
